module.exports = __webpack_public_path__ + "static/img/toritori.cf49dc91.png";